<template>
  <section id="account-panel">
    <div class="page-inner">
      <div class="content-panel">
        <h1 class="panel-title">Cadastro</h1>

        <div class="info-columns">
          <div class="info-col">
            <h2 class="info-heading">Dados da Empresa</h2>

            <div class="info-row">
              <span class="info-label">Nome Fantasia</span
              ><span>{{ companyInfo.doingBusinessAs }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Razão social</span
              ><span>{{ companyInfo.companyName }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">CNPJ</span
              ><span>{{ companyInfo.nationalCompanyId }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Inscrição estadual</span
              ><span>{{ companyInfo.stateCompanyId }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Inscrição municipal</span
              ><span>{{ companyInfo.municipalCompanyId }}</span>
            </div>
          </div>

          <div class="info-col">
            <h2 class="info-heading">Endereço da Empresa</h2>

            <div class="info-row">
              <span class="info-label">Estado</span
              ><span>{{ address.state }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Cidade</span
              ><span>{{ address.city }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Bairro</span
              ><span>{{ address.neighborhood }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Logradouro</span
              ><span>{{ `${address.street}, ${address.number}` }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Complemento</span
              ><span>{{ address.complement || "-" }}</span>
            </div>
          </div>
        </div>

        <div class="notice-box">
          <span class="material-icons notice-icon">info</span>
          <span>
            Para solicitar alterações no cadastro entre em contato com a Onii
            pelo email suporte@onii.app
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["companyInfo", "address"])
  }
};
</script>

<style scoped>
#account-panel {
  min-height: 100vh;
  background-color: #f8f7fa;
  padding: 1.5rem;
}

.page-inner {
  width: 100%;
}

.content-panel {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07), 0 1px 2px rgba(0, 0, 0, 0.04);
  border: 1px solid #f3f4f6;
  padding: 1.5rem;
}

.panel-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #4a4453;
  margin-bottom: 1.5rem;
}

/* ── colunas de informação ── */
.info-columns {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
}

.info-col {
  flex: 1 1 240px;
  min-width: 0;
}

.info-heading {
  font-size: 0.95rem;
  font-weight: 700;
  color: #4a4453;
  margin-bottom: 0.85rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid #f0f0f0;
}

.info-row {
  display: flex;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #374151;
  padding: 0.3rem 0;
}

.info-label {
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
  min-width: 140px;
  flex-shrink: 0;
}

.info-label::after {
  content: ":";
}

/* ── caixa de aviso ── */
.notice-box {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  background: #f0f7ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  padding: 0.85rem 1rem;
  font-size: 0.875rem;
  color: #1e40af;
}

.notice-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
  margin-top: 1px;
}

.notice-box a {
  color: #1e40af;
}
</style>
